'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setStore = setStore;
exports.getStore = getStore;
exports.connectWithStore = connectWithStore;

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxLogger = require('redux-logger');

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _middleware = require('./middleware');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _mason = {};

function setStore(store) {
  _mason.store = store;
}

function getStore() {
  return _mason.store;
}

function connectWithStore(WrappedComponent) {
  if (!_mason.store) {
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
    var middleware = composeEnhancers((0, _redux.applyMiddleware)(_middleware.api, (0, _reduxLogger.createLogger)()));
    _mason.store = (0, _redux.createStore)(_reducers2.default, {}, middleware);
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var ConnectedWrappedComponent = _reactRedux.connect.apply(undefined, args)(WrappedComponent);

  return function (props) {
    return (0, _reactHyperscript2.default)(ConnectedWrappedComponent, _extends({}, props, {
      store: _mason.store
    }));
  };
}